module.exports = __webpack_public_path__ + "static/media/PHED.fb8f8b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/PHED.png
// module id = 378
// module chunks = 25